import React from "react";


const rightPanelStyles = `
/* ── RIGHT PANEL ── */
  .pan-right {
    background: oklch(0.22 0.04 264.84);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 3rem;
    position: relative;
    overflow: hidden;
  }
  .pan-right-blob1 {
    position: absolute;
    width: 340px; height: 340px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(55,138,221,0.22) 0%, transparent 70%);
    top: -80px; right: -80px;
    pointer-events: none;
  }
  .pan-right-blob2 {
    position: absolute;
    width: 260px; height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(249,115,22,0.18) 0%, transparent 70%);
    bottom: 40px; left: -60px;
    pointer-events: none;
  }
  .pan-right-blob3 {
    position: absolute;
    width: 150px; height: 150px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(52,211,153,0.14) 0%, transparent 70%);
    bottom: 120px; right: 60px;
    pointer-events: none;
  }
  .pan-right-grid {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
    background-size: 40px 40px;
    pointer-events: none;
  }

  .pan-right-logo {
    display: flex; align-items: center; gap: 10px;
    position: relative; z-index: 1;
  }
  .pan-right-logo-dot {
    width: 34px; height: 34px;
    background: #F97316;
    border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
  }
  .pan-right-logo-dot svg { width: 18px; height: 18px; fill: none; stroke: #fff; stroke-width: 2.2; stroke-linecap: round; }
  .pan-right-logo-name { font-size: 16px; font-weight: 600; color: #fff; letter-spacing: -0.2px; }

  .pan-hero { position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center; gap: 16px; padding: 2rem 0; }
  .pan-hero-pill {
    display: inline-flex; align-items: center; gap: 6px;
    background: rgba(249,115,22,0.16);
    border: 1px solid rgba(249,115,22,0.35);
    border-radius: 20px; padding: 5px 14px;
    color: #F97316; font-size: 12px; font-weight: 600;
    letter-spacing: 0.2px; width: fit-content;
  }
  .pan-hero-pill svg { width: 12px; height: 12px; }
  .pan-hero-h1 {
    font-size: 30px; font-weight: 700; color: #fff;
    line-height: 1.22; letter-spacing: -1px;
  }
  .pan-hero-h1 span { color: #F97316; }
  .pan-hero-sub { font-size: 14px; color: rgba(255,255,255,0.5); line-height: 1.65; font-weight: 300; }
  .pan-hero-stat {
    display: flex; gap: 1.5rem; margin-top: 8px;
  }
  .pan-stat-item { display: flex; flex-direction: column; gap: 2px; }
  .pan-stat-val { font-size: 20px; font-weight: 700; color: #fff; letter-spacing: -0.5px; }
  .pan-stat-label { font-size: 11px; color: rgba(255,255,255,0.4); font-weight: 400; }

  .pan-features { display: flex; flex-direction: column; gap: 10px; position: relative; z-index: 1; }
  .pan-feat {
    display: flex; align-items: center; gap: 14px;
    padding: 14px 16px;
    background: rgba(255,255,255,0.05);
    border-radius: 14px;
    border: 1px solid rgba(255,255,255,0.08);
    transition: background 0.2s, border-color 0.2s;
  }
  .pan-feat:hover { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.13); }
  .pan-feat-icon {
    width: 38px; height: 38px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .pan-feat-icon svg { width: 18px; height: 18px; fill: none; stroke-width: 2; stroke-linecap: round; stroke-linejoin: round; }
  .pan-feat-icon.green { background: rgba(52,211,153,0.15); }
  .pan-feat-icon.green svg { stroke: #34d399; }
  .pan-feat-icon.blue { background: rgba(96,165,250,0.15); }
  .pan-feat-icon.blue svg { stroke: #60a5fa; }
  .pan-feat-icon.orange { background: rgba(249,115,22,0.15); }
  .pan-feat-icon.orange svg { stroke: #F97316; }
  .pan-feat-title { font-size: 13px; font-weight: 600; color: #fff; margin-bottom: 2px; }
  .pan-feat-sub { font-size: 11.5px; color: rgba(255,255,255,0.4); font-weight: 300; }

  /* SUCCESS STATE */
  .pan-success {
    display: flex; flex-direction: column; align-items: center;
    text-align: center; gap: 1.25rem; padding: 1rem 0;
  }
  .pan-success-ring {
    width: 64px; height: 64px; border-radius: 50%;
    background: rgba(52,211,153,0.1);
    border: 2px solid #34d399;
    display: flex; align-items: center; justify-content: center;
  }
  .pan-success-ring svg { width: 30px; height: 30px; fill: none; stroke: #34d399; stroke-width: 2.5; stroke-linecap: round; stroke-linejoin: round; }
  .pan-success-title { font-size: 20px; font-weight: 700; color: #0f1c2e; letter-spacing: -0.4px; }
  .pan-success-sub { font-size: 13px; color: #6b7a90; }
  .pan-success-info {
    width: 100%; background: #f7f9fc; border-radius: 12px;
    border: 1px solid #dce4f0; overflow: hidden;
  }
  .pan-success-row {
    display: flex; justify-content: space-between; align-items: center;
    padding: 12px 16px; border-bottom: 1px solid #dce4f0;
  }
  .pan-success-row:last-child { border-bottom: none; }
  .pan-success-key { font-size: 12px; color: #6b7a90; font-weight: 400; }
  .pan-success-val { font-size: 13px; font-weight: 600; color: #0f1c2e; font-family: 'JetBrains Mono', monospace; }
  .pan-badge-row { display: flex; gap: 8px; }
  .pan-badge {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 5px 12px; border-radius: 20px;
    background: rgba(52,211,153,0.1);
    border: 1px solid rgba(52,211,153,0.25);
    color: #059669; font-size: 11.5px; font-weight: 600;
  }
  .pan-badge svg { width: 12px; height: 12px; }
}

/* RESPONSIVE */
  @media (max-width: 900px) {
    .pan-split { grid-template-columns: 1fr; min-height: auto; }
    .pan-right { display: none; }
    .pan-left { padding: 2rem 1.25rem 6rem; justify-content: flex-start; }
    .pan-logo { margin-bottom: 1.5rem; }
    .pan-card { padding: 1.75rem 1.5rem; }
    .pan-card-title { font-size: 20px; }
    .pan-boxes-wrap { gap: 4px; }
    .pan-box { width: 30px; height: 42px; font-size: 14px; }
    .pan-hero-h1 { font-size: 24px; }
  }

  @media (max-width: 400px) {
    .pan-box { width: 26px; height: 40px; font-size: 13px; border-radius: 8px; }
    .pan-boxes-wrap { gap: 3px; }
    .pan-card { padding: 1.5rem 1.25rem; }
  }
`;
// const IconBolt = () => (
//   <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
// );
const IconShield = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
);
const IconZap = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
);
const IconUsers = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
);
const IconCheck = () => (
  <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
);
const IconLock = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
);
const IconAlert = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
);
const IconStar = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
);

export default function JourneyRightPanel({
  title = "Get instant loan approval today",
  subtitle = "Fast, secure & paperless verification.",
  showStats = true,
}) {
  return (
    <>
      <style>{rightPanelStyles}</style>

     <div className="pan-right" aria-hidden="true">
        <div className="pan-right-grid" />
        <div className="pan-right-blob1" />
        <div className="pan-right-blob2" />
        <div className="pan-right-blob3" />

        <div className="pan-right-logo">
        {/* <div className="pan-right-logo-dot"><IconBolt /></div> */}
        <span className="pan-right-logo-name">B4Salary</span>
        </div>

        <div className="pan-hero">
        <div className="pan-hero-pill">
            <IconStar />
            Instant approval
        </div>
        <h2 className="pan-hero-h1">
            Get instant<br /><span>loan approval</span><br />today
        </h2>
        <p className="pan-hero-sub">
            Fast, secure &amp; paperless verification.<br />
            Loans from ₹5,000 to ₹1,00,000 in minutes.
        </p>
        <div className="pan-hero-stat">
            <div className="pan-stat-item">
            <span className="pan-stat-val">10L+</span>
            <span className="pan-stat-label">Happy users</span>
            </div>
            <div className="pan-stat-item">
            <span className="pan-stat-val">120s</span>
            <span className="pan-stat-label">Avg. approval</span>
            </div>
            {/* <div className="pan-stat-item">
            <span className="pan-stat-val">4.8★</span>
            <span className="pan-stat-label">App rating</span>
            </div> */}
        </div>
        </div>

        <div className="pan-features">
        <div className="pan-feat">
            <div className="pan-feat-icon green"><IconShield /></div>
            <div>
            <div className="pan-feat-title">100% secure</div>
            <div className="pan-feat-sub">Bank-grade encryption on all data</div>
            </div>
        </div>
        <div className="pan-feat">
            <div className="pan-feat-icon blue"><IconZap /></div>
            <div>
            <div className="pan-feat-title">Instant approval</div>
            <div className="pan-feat-sub">Decision in under 120 seconds</div>
            </div>
        </div>
        <div className="pan-feat">
            <div className="pan-feat-icon orange"><IconUsers /></div>
            <div>
            <div className="pan-feat-title">Trusted by users</div>
            <div className="pan-feat-sub">Rated 4.8★ on Play Store &amp; App Store</div>
            </div>
        </div>
        </div>
    </div>

    </>
  );
}